export const bs = {
  common: {
    save: "Sačuvaj",
    cancel: "Odustani",
    close: "Zatvori",
    delete: "Obriši",
    edit: "Uredi",
    create: "Kreiraj",
    update: "Ažuriraj",
    loading: "Učitavanje",
    error: "Greška",
    saved: "Sačuvano",
    yes: "Da",
    no: "Ne",
    all: "Sve",
    apply: "Primijeni",
    signOut: "Odjavi se",
    confirm: "Potvrdi",
    optionalNotes: "Opcionalne napomene",
    confirmDelete: "Potvrdi brisanje",
    current: "Trenutno",
    ok: "OK",
    warning: "Upozorenje",
    success: "Uspješno",
    back: "Nazad",
    copied: "Kopirano",
    refresh: "Osvježi",
    add: "Dodaj",
    change: "Promijeni",
    countryCode: "Pozivni broj",
    none: "Nema",
  },

  auth: {
    login: "Prijava",
    logout: "Odjava",
    register: "Registracija",
    email: "Email",
    phone: "Telefon",
    password: "Lozinka",
    confirmPassword: "Potvrdi lozinku",
    firstName: "Ime",
    lastName: "Prezime",
    accountName: "Naziv računa",
    loginFailed: "Prijava nije uspjela.",
    signInSubtitle: "Upravljajte apartmanima, rezervacijama i gostima.",
    forgotPassword: "Zaboravljena lozinka?",
    forgotPasswordSubtitle:
      "Unesite email i poslat ćemo vam upute za resetovanje lozinke.",
    sendResetLink: "Pošalji link za resetovanje",
    backToLogin: "Nazad na prijavu",
    or: "ili",
    loginWithGoogle: "Nastavi sa Google",
    loginWithFacebook: "Nastavi sa Facebook",
    noAccount: "Nemate račun?",
    createAccount: "Kreiraj račun",
    alreadyHaveAccount: "Već imate račun?",
    registerSubtitle:
      "Kreirajte RentPilot račun i počnite upravljati smještajem.",
    verifyEmailBanner:
      "Molimo potvrdite email adresu prije korištenja svih RentPilot funkcija.",
    resendVerificationEmail: "Pošalji ponovo",
    iVerified: "Potvrdio sam",
    resetPassword: "Resetuj lozinku",
    resetPasswordSubtitle: "Unesite novu lozinku za svoj RentPilot račun.",
    newPassword: "Nova lozinka",
    invalidResetLink:
      "Link za resetovanje lozinke nije ispravan ili je nepotpun.",
  },

  tabs: {
    calendar: "Kalendar",
    properties: "Objekti",
    statistics: "Statistika",
    profile: "Profil",
    team: "Tim",
    support: "Podrška",
    cleaningTasks: "Zadaci",
    invoices: "Fakture",
    menu: "Meni",
    reservations: "Rezervacije",
    guests: "Gosti",
  },

  cleaners: {
    title: "Tim",
    add: "Dodaj",
    cleaners: "Članovi tima",
    newCleaner: "Novi član tima",
    createCleaner: "Kreiraj člana tima",
    noCleaners: "Još nema članova tima.",
    schedule: "Raspored",
    noTasks: "Nema zadataka čišćenja.",
    assignCleaner: "Dodijeli člana tima",
    cleanedHistory: "Historija čišćenja",
    noCleanedHistory: "Još nema očišćenih jedinica.",
    failedCreateCleaner: "Nije moguće kreirati člana tima.",
    deleteQuestion: "Obrisati {{name}}?",
    description: "Upravljajte članovima tima i njihovim pristupom aplikaciji.",
    teamAccess: "Pristup timu",
    members: "članova",
    addMemberDescription:
      "Dodajte menadžera, posmatrača ili sobaricu u svoj račun.",
    roleOverview: "Pregled uloga",
    managerDescription:
      "Može upravljati rezervacijama, objektima, gostima, zadacima i timom.",
    viewerDescription: "Može pregledati kalendar bez upravljanja podacima.",
    cleanerDescription: "Vidi samo zadatke koji su dodijeljeni za čišćenje.",
  },

  cleaning: {
    myTasks: "Moji zadaci",
    today: "Danas",
    upcoming: "Nadolazeće",
    done: "Završeno",
    noTasksToday: "Nema zadataka za danas.",
    noUpcomingTasks: "Nema nadolazećih zadataka.",
    noDoneTasks: "Nema završenih zadataka.",
    scheduled: "Zakazano",
    cleanedAt: "Očišćeno",
    assignedTo: "Dodijeljeno",
    unassigned: "Nije dodijeljeno",
    start: "Započni",
    markCleaned: "Označi očišćeno",
    futureTaskCannotBeCompleted:
      "Ovaj zadatak se može završiti na dan kada je zakazan.",
    status: {
      pending: "Na čekanju",
      in_progress: "U toku",
      done: "Završeno",
      cancelled: "Otkazano",
    },
    description:
      "Pregled današnjih zadataka, nadolazećeg čišćenja i historije završenih čišćenja.",
  },

  calendar: {
    unit: "Jedinica",
    noUnits: "Nema jedinica",
    filters: "Filteri",
    startDate: "Početni datum",
    endDate: "Krajnji datum",
    thisWeek: "Ova sedmica",
    twoWeeks: "Dvije sedmice",
    threeWeeks: "Tri sedmice",
    thisMonth: "Ovaj mjesec",
    occupied: "Zauzeto",
    unavailable: "Nedostupno",
    rangeOverlaps: "Odabrani period se preklapa sa postojećom rezervacijom.",
    occupiedCellMessage: "Ova jedinica već ima rezervaciju na odabrani datum.",
    selectCheckIn: "Odaberite dolazak",
    selectCheckOut: "Odaberite odlazak",
    clear: "Očisti",
    multi: "Više",
    single: "Jedan",
    next7Days: "Narednih 7 dana",
    next14Days: "Narednih 14 dana",
    selectedStart: "Odabran početak",
    tapCheckoutDate: "Odaberite datum odjave za kreiranje rezervacije",
    subtitle:
      "Pregled jedinica, rezervacija, plaćanja i boravaka koji pokreću čišćenje.",
    available: "Slobodno",
    addObjects: "Dodaj objekte",
    addObjectsDescription:
      "Kreiraj prvi objekat i jedinicu da započneš upravljanje rezervacijama.",
    month: "Mjesec",
    next: "Dalje",
    allUnits: "Svi apartmani",
    checkInAfter: "Ulaz od 14:00",
    checkOutBefore: "Izlaz do 10:00",
    cleaning: "Čišćenje",
    private: "Privatno",
    closed: "Zatvoreno",
    today: "Danas",
    fullYear: "Cijela godina",
    availableDates: "Slobodni termini",
    availableDatesByUnit: "Slobodni termini po apartmanima",
    shown: "prikazano",
    terms: "termina",
    noFreePeriods: "Nema slobodnih termina",
  },

  booking: {
    newBooking: "Nova rezervacija",
    bookingDetails: "Detalji rezervacije",
    guestFirstName: "Ime gosta",
    guestLastName: "Prezime gosta",
    guest: "Gost",
    phone: "Telefon",
    email: "Email",
    unit: "Jedinica",
    checkIn: "Dolazak",
    checkOut: "Odlazak",
    nights: "Noći",
    pricePerNight: "Cijena po noći",
    total: "Ukupno",
    status: "Status",
    payment: "Plaćanje",
    paymentStatus: "Status plaćanja",
    unpaid: "Nije plaćeno",
    deposit: "Akontacija",
    paid: "Plaćeno",
    reserved: "Rezervisano",
    checkedIn: "Prijavljen",
    checkedOut: "Odjavljen",
    cancelled: "Otkazano",
    notes: "Napomene",
    createBooking: "Kreiraj rezervaciju",
    failedCreate: "Rezervacija nije kreirana.",
    guestFirstNamePlaceholder: "John",
    guestLastNamePlaceholder: "Smith",
    phonePlaceholder: "+387...",
    emailPlaceholder: "john@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Dolazak oko 18:00",
    currency: "Valuta",
    dateRange: "Datumi boravka",
    selectDates: "Odaberite datume",
    selectCheckIn: "Odaberite datum dolaska",
    selectedDateOccupied: "Ovaj datum je već zauzet.",
    selectedRangeOverlaps:
      "Odabrani datumi se preklapaju sa postojećom rezervacijom.",
    numberOfGuests: "Broj gostiju",
    checkoutAfterCheckin: "Check-out mora biti nakon check-in datuma.",
    contactGuest: "Kontaktiraj gosta",
    invoice: "Faktura",
    whatsapp: "WhatsApp",
    missingEmail: "Ovaj gost nema email adresu.",
    missingPhone: "Ovaj gost nema broj telefona.",
    noContactInfo: "Ovaj gost nema email adresu ni broj telefona.",
    confirmSendInvoice: "Poslati fakturu ovom gostu?",
    invoiceSent: "Faktura je poslana.",
    failedSendInvoice: "Slanje fakture nije uspjelo.",
    booking: "Rezervacija",
    editBooking: "Uredi rezervaciju",
    saveBooking: "Sačuvaj rezervaciju",
    sendInvoice: "Pošalji fakturu",
    cancelBooking: "Otkaži rezervaciju",
    cancelBookingQuestion:
      "Da li ste sigurni da želite otkazati ovu rezervaciju?",
    bookingCreated: "Rezervacija je kreirana.",
    bookingUpdated: "Rezervacija je ažurirana.",
    bookingCancelled: "Rezervacija je otkazana.",
    failedUpdate: "Ažuriranje rezervacije nije uspjelo.",
    failedCancel: "Otkazivanje rezervacije nije uspjelo.",
    unitMissing: "Jedinica nedostaje.",
    emailUnavailable: "Email nije dostupan.",
    emailSubject: "Informacije o rezervaciji",
    emailBody: "Pozdrav, ovo su detalji vaše rezervacije.",
    whatsappMessage: "Pozdrav, ovo su detalji vaše rezervacije.",
    missingGuestEmail: "Email gosta nedostaje.",
    confirmSendInvoiceMessage: "Faktura će biti poslana na email adresu gosta.",
    checked_in: "Prijavljen",
    checked_out: "Odjavljen",
  },

  bookingMessages: {
    title: "WhatsApp poruka",
    templateOne:
      "Pozdrav {{guest}}, vaša rezervacija za {{unit}} je potvrđena od {{checkIn}} do {{checkOut}}.",
    templateTwo:
      "Pozdrav {{guest}}, hvala na rezervaciji. Check-in je {{checkIn}}, a check-out {{checkOut}}.",
    templateThree:
      "Pozdrav {{guest}}, radujemo se vašem dolasku u {{unit}}. Vaši datumi su {{checkIn}} - {{checkOut}}.",
    templateButton: "Šablon {{number}}",
    customPlaceholder: "Napišite poruku...",
    openWhatsApp: "Otvori WhatsApp",
    customMessage: "Prilagođena poruka",
    invalidPhone: "Neispravan broj telefona.",
    missingPhone: "Broj telefona nedostaje.",
    whatsappUnavailable: "WhatsApp nije dostupan.",
  },

  properties: {
    title: "Objekti",
    newProperty: "Novi objekat",
    createProperty: "Kreiraj objekat",
    propertyName: "Naziv objekta",
    address: "Adresa",
    city: "Grad",
    notes: "Napomene",
    noUnits: "Nema jedinica",
    units: "jedinica",
    newUnit: "Nova jedinica",
    createUnit: "Kreiraj jedinicu",
    unitName: "Naziv jedinice",
    type: "Tip",
    capacity: "Kapacitet",
    defaultPricePerNight: "Zadana cijena po noći",
    noDefaultPrice: "Nema zadane cijene",
    guests: "gostiju",
    disable: "Onemogući",
    enable: "Omogući",
    deleteProperty: "Obriši objekat",
    deletePropertyQuestion:
      "Obrisati {{name}}? Ovo radi samo ako nema historiju rezervacija.",
    deleteUnit: "Obriši jedinicu",
    deleteUnitQuestion:
      "Obrisati ovu jedinicu? Ako ima historiju rezervacija, možete je samo onemogućiti.",
    failedCreateProperty: "Objekat nije kreiran.",
    failedCreateUnit: "Jedinica nije kreirana.",
    apartment: "Apartman",
    room: "Soba",
    studio: "Studio",
    house: "Kuća",
    other: "Ostalo",
    newPropertyPlaceholder: "Apartmani Sarajevo",
    addressPlaceholder: "Ulica 1",
    cityPlaceholder: "Sarajevo",
    notesPlaceholder: "Opcionalne napomene",
    unitNamePlaceholder: "Apartman A",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / noć",
    deletePropertySuccess: "Objekat je obrisan.",
    deleteUnitSuccess: "Jedinica je obrisana.",
    addUnit: "Dodaj jedinicu",
    activeUnits: "aktivnih jedinica",
    inactiveUnits: "neaktivnih jedinica",
    calendarSync: "Sinhronizacija kalendara",
    calendarSyncHelp:
      "Zalijepite Airbnb i Booking.com iCal export linkove ovdje. RentPilot će importovati te kalendare i blokirati odgovarajuće datume.",
    airbnbIcalLink: "Airbnb iCal link",
    bookingIcalLink: "Booking.com iCal link",
    rentPilotExportLink: "RentPilot export link",
    rentPilotExportCalendar: "RentPilot export kalendar",
    rentPilotExportHelp:
      "Kopirajte ovaj link u Airbnb i Booking.com kako bi mogli blokirati datume iz RentPilota.",
    rentPilotExportHelpLong:
      "Zalijepite ovaj link u postavke za import kalendara na Airbnb i Booking.com kako bi te platforme mogle blokirati datume iz RentPilota.",
    airbnbConnected: "Airbnb povezan",
    airbnbNotConnected: "Airbnb nije povezan",
    bookingConnected: "Booking povezan",
    bookingNotConnected: "Booking nije povezan",
    noExternalCalendarsConnected: "Nema povezanih eksternih kalendara.",
    copyShareExportLink: "Kopiraj export link",
    exportLinkMissing:
      "Export link nedostaje. Backend nije vratio calendar_export_url za ovu jedinicu.",
    exportLinkCopied: "Export link je kopiran.",
    editUnit: "Uredi jedinicu",
    saveUnit: "Sačuvaj jedinicu",
    noUnitsDescription:
      "Dodajte sobe/apartmane kako bi se rezervacije i zadaci čišćenja mogli povezati s ovim objektom.",
    activateUnit: "Aktiviraj jedinicu",
    deactivateUnit: "Deaktiviraj jedinicu",
    failedDeleteProperty: "Brisanje objekta nije uspjelo.",
    failedDeleteUnit: "Brisanje jedinice nije uspjelo.",
    failedUpdateUnit: "Ažuriranje jedinice nije uspjelo.",
  },

  statistics: {
    title: "Statistika",
    revenue: "Prihod",
    bookings: "Rezervacije",
    nights: "Noći",
    averageBooking: "Prosjek rezervacije",
    breakdown: "Pregled",
    noStatistics: "Nema statistike za odabrane filtere.",
    groupBy: "Grupiši po",
    unit: "Jedinica",
    property: "Objekat",
    month: "Mjesec",
    payment: "Plaćanje",
    sevenDays: "7 dana",
    fourteenDays: "14 dana",
    thirtyDays: "30 dana",
    thisMonth: "Ovaj mjesec",
    allProperties: "Svi objekti",
    allUnits: "Sve jedinice",
    byUnit: "Po jedinici",
    byProperty: "Po objektu",
    byMonth: "Po mjesecu",
    netProfit: "Neto dobit",
    occupancy: "Popunjenost",
    profitMargin: "Profitna marža",
    expenseRatio: "Omjer troškova",
    revenueByUnit: "Prihod po jedinici",
    revenueByApartment: "Prihod po apartmanu",
    noRevenueForPeriod: "Nema prihoda za odabrani period.",
    noExpensesForPeriod: "Nema troškova za odabrani period.",
    manualVsRecurringExpenses: "Ručni i ponavljajući troškovi",
    cashflow: "Tok novca",
    latestNetProfit: "Zadnji neto profit: {{amount}}",
    performanceBreakdown: "Pregled performansi",
    breakdownMeta: "{{bookings}} rezervacija · {{nights}} noćenja",
    margin: "Marža",
    revenueExpensesHint: "{{revenue}} prihod · {{expenses}} troškovi",
    expenses: "Troškovi",
    expensesByCategory: "Troškovi po kategoriji",
    filters: "Filteri",
  },

  expenses: {
    expenses: "Troškovi",
    newExpense: "Novi trošak",
    editExpense: "Uredi trošak",
    newRecurringExpense: "Novi ponavljajući trošak",
    editRecurringExpense: "Uredi ponavljajući trošak",
    manualExpenses: "Ručni troškovi",
    recurringExpenses: "Ponavljajući troškovi",
    totalExpenses: "Ukupni troškovi",
    noExpenses: "Još nema troškova.",
    noRecurringExpenses: "Još nema ponavljajućih troškova.",
    name: "Naziv",
    category: "Kategorija",
    categoryPlaceholder: "Čišćenje, režije, održavanje...",
    amount: "Iznos",
    date: "Datum",
    frequency: "Učestalost",
    monthly: "Mjesečno",
    yearly: "Godišnje",
    interval: "Interval",
    dayOfMonth: "Dan u mjesecu",
    startDate: "Početni datum",
    endDate: "Završni datum",
    active: "Aktivno",
    inactive: "Neaktivno",
    noProperty: "Bez objekta",
    noUnit: "Bez jedinice",
    uncategorized: "Nekategorisano",
    expensesByCategory: "Troškovi po kategoriji",
    expensesByType: "Troškovi po tipu",
    expensesByUnit: "Troškovi po jedinici",
    addExpense: "Dodaj trošak",
    oneTimeExpense: "Jednokratni trošak",
    oneTimeExpenseDescription:
      "Koristi za pojedinačni trošak, npr. popravku, peškire ili jednu kupovinu.",
    recurringExpense: "Ponavljajući trošak",
    recurringExpenseDescription:
      "Koristi za troškove koji se ponavljaju, npr. internet, pretplate ili mjesečne potrepštine.",
  },

  profile: {
    title: "Profil",
    firstName: "Ime",
    lastName: "Prezime",
    phone: "Telefon",
    saveProfile: "Sačuvaj profil",
    profileUpdated: "Profil je ažuriran.",
    updateEmail: "Ažuriraj email",
    currentPassword: "Trenutna lozinka",
    emailUpdated: "Email je ažuriran.",
    password: "Lozinka",
    newPassword: "Nova lozinka",
    confirmNewPassword: "Potvrdi novu lozinku",
    updatePassword: "Ažuriraj lozinku",
    passwordUpdated: "Lozinka je ažurirana.",
    passwordsDoNotMatch: "Nova lozinka i potvrda se ne poklapaju.",
    language: "Jezik",
    signOutQuestion: "Da li ste sigurni da se želite odjaviti?",
    failedProfileUpdate: "Profil nije ažuriran.",
    failedEmailUpdate: "Email nije ažuriran.",
    failedPasswordUpdate: "Lozinka nije ažurirana.",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Ime",
    lastNamePlaceholder: "Prezime",
    currentPasswordPlaceholder: "Trenutna lozinka",
    newPasswordPlaceholder: "Nova lozinka",
    confirmNewPasswordPlaceholder: "Potvrdi novu lozinku",
    signOut: "Odjavi se",
    currencySettings: "Valuta",
  },

  currency: {
    currency: "Valuta",
    currencyUpdated: "Valuta promijenjena",
    defaultCurrency: "Zadana valuta",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "Valuta nije promijenjena.",
  },

  support: {
    title: "Podrška",
    needSupport: "Potrebna vam je pomoć?",
    description:
      "Kontaktirajte nas ako vam treba pomoć oko računa, rezervacija, objekata, čistača ili pretplate.",
    callSupport: "Pozovi podršku",
    emailSupport: "Pošalji email podršci",
  },

  subscription: {
    title: "Pretplata",
    subtitle: "Odaberite paket koji odgovara vašem načinu izdavanja.",
    currentPlan: "Trenutni paket",
    freeNotice: "Trenutno koristite besplatni paket.",
    perMonth: "/ mjesec",
    choosePlan: "Odaberi paket",
    manageBilling: "Upravljaj pretplatom",
    upgradeRequired: "Potrebna nadogradnja",
    upgradeRequiredMessage:
      "Dostigli ste ograničenje trenutnog paketa. Nadogradite pretplatu.",
    accessWarningTitle: "Pristup RentPilotu uskoro ističe",

    accessWarningMessage:
      "Vaš pristup RentPilotu ističe {{date}}. Odaberite ili obnovite paket prije tog datuma kako biste nastavili unositi i mijenjati podatke.",

    customAccessWarningMessage:
      "Vaš prilagođeni RentPilot paket ističe {{date}}. Kontaktirajte RentPilot podršku i dogovorite plaćanje prije tog datuma kako biste nastavili koristiti aplikaciju.",

    accessExpiredTitle: "Pristup RentPilotu je ograničen",

    accessExpiredMessage:
      "Vaša pretplata je istekla ili nije plaćena. I dalje možete pregledati postojeće podatke, ali unos i izmjene su onemogućeni dok uplata ne bude evidentirana.",

    customAccessExpiredMessage:
      "Vaš prilagođeni RentPilot paket je istekao ili nije plaćen. I dalje možete pregledati postojeće podatke, ali unos i izmjene su onemogućeni. Kontaktirajte RentPilot podršku kako biste dogovorili plaćanje i ponovo aktivirali pristup.",

    contactAccountOwnerMessage:
      "Kontaktirajte vlasnika računa kako bi dogovorio plaćanje i ponovo aktivirao puni pristup.",

    viewPlansCta: "Pregledaj pakete",

    contactSupportCta: "Kontaktiraj podršku",

    noticeCloseCta: "Razumijem",
    billingPeriod: "Period naplate",
    trialExpiresSoonBanner:
      "Vaš probni period ističe za {{hours}} sati. Da nastavite koristiti RentPilot, odaberite paket u web aplikaciji.",
    trialExpiresSoonCta: "Odaberi paket",
    billingPeriodDescription:
      "Odaberite koliko mjeseci želite platiti unaprijed.",
    planColumn: "Paket",
    limitColumn: "Limit",
    priceColumn: "Cijena",
    discountColumn: "Popust",
    featuresColumn: "Uključeno",
    actionColumn: "Akcija",
    recommended: "Preporučeno",
    discountBadge: "{{discount}}% popusta",
  },

  menu: {
    pricing: "Pretplata",
    pricingDescription: "Pregled trenutnog paketa i opcija naplate.",
    currentPlan: "Trenutni paket",
    pricingComingSoon: "Upravljanje cijenama će biti povezano ovdje.",
    myAccount: "Moj račun",
    myAccountDescription: "Profil, email i lozinka.",
    support: "Podrška",
    supportDescription:
      "Kontaktirajte podršku ili pogledajte pomoćne informacije.",
    settings: "Postavke",
    settingsDescription: "Izgled aplikacije, jezik i valuta",
    privacy: "Privatnost i podaci o trgovcu",
    privacyDescription:
      "Podaci o firmi, korisničkom servisu i zaštiti privatnosti.",
  },

  settings: {
    appAppearance: "Izgled aplikacije",
    fontSize: "Veličina fonta",
    fontSmall: "Malo",
    fontMedium: "Srednje",
    fontLarge: "Veliko",
    fontVeryLarge: "Jako veliko",
    bookingColors: "Boje rezervacija",
    theme: "Tema",
    themeSystem: "Sistemska",
    themeLight: "Svijetla",
    themeDark: "Tamna",
  },

  roles: {
    role: "Uloga",
    owner: "Vlasnik",
    manager: "Menadžer",
    cleaner: "Sobarica",
    viewer: "Posmatrač",
    teamMember: "Član tima",
  },

  invoices: {
    title: "Poslane fakture",
    description: "Pregled poslanih faktura i historije slanja.",
    emptyTitle: "Još nema faktura",
    empty: "Još nije poslana nijedna faktura.",
    failedLoad: "Nije moguće učitati fakture.",
    sentAt: "Poslano",
    status: {
      pending: "Na čekanju",
      sent: "Poslano",
      failed: "Neuspješno",
    },
  },

  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  guests: {
    eyebrow: "Gosti",
    title: "Lista i povijest gostiju",
    subtitle:
      "Pregled kontakata, boravaka, prihoda i napomena za brži rad s povratnim gostima.",
    newGuest: "Novi gost",
    totalGuests: "Ukupno gostiju",
    returningGuests: "Povratni gosti",
    marketingConsent: "Marketing consent",
    totalRevenue: "Ukupan prihod",
    directory: "Imenik",
    contacts: "Kontakti gostiju",
    searchPlaceholder: "Pretraži ime, e-poštu ili telefon",
    emptyTitle: "Nema gostiju",
    emptySubtitle: "Dodajte prvog gosta ili napravite rezervaciju.",
    contactDetails: "Kontakt podaci",
    firstName: "Ime",
    lastName: "Prezime",
    email: "E-pošta",
    phone: "Telefon",
    country: "Država",
    documentNumber: "Broj dokumenta",
    notes: "Napomena",
    addGuest: "Dodaj gosta",
    hasConsent: "Ima consent",
    noConsent: "Bez consenta",
    stays: "boravka",
    lastStay: "Zadnji odlazak",
    deleteConfirm:
      "Obrisati gosta? Gost se ne može obrisati ako ima rezervacije.",
  },

  reservations: {
    eyebrow: "Rezervacije",
    title: "Rezervacije",
    subtitle:
      "Pregled gostiju, uplata, izvora rezervacije i brzih potvrda za slanje.",
    newReservation: "Nova rezervacija",
    active: "Aktivne rezervacije",
    completed: "Završene rezervacije",
    cancelled: "Otkazane rezervacije",
    totalRevenue: "Ukupan prihod",
    source: "Izvor",
    allSources: "Svi izvori",
    reservations: "rezervacija",
    noReservationsForUnit: "Nema rezervacija za ovu jedinicu.",
    unknownGuest: "Nepoznat gost",
    nights: "noći",
  },

  bookingSources: {
    manual: "Ručno",
    airbnb: "Airbnb",
    booking: "Booking",
    external: "Eksterni kalendar",
    other: "Ostalo",
  },

  paymentStatus: {
    unpaid: "Nije plaćeno",
    deposit: "Avans",
    paid: "Plaćeno",
  },

  faq: {
    eyebrow: "Pomoć",
    title: "FAQ i pomoć",
    subtitle: "Brzi odgovori za najčešće stvari u RentPilotu.",
    needHelp: "Treba vam dodatna pomoć?",
    needHelpText: "Pošaljite poruku podršci i opišite problem što preciznije.",
    contactSupport: "Kontaktiraj podršku",
    items: {
      bookingSource: {
        question: "Kako znam odakle je došla rezervacija?",
        answer:
          "Svaka rezervacija ima izvor: ručno, Airbnb, Booking, eksterni kalendar ili ostalo. Rezervacije uvezene preko iCal kalendara automatski dobijaju izvor Airbnb ili Booking.",
      },
      ical: {
        question: "Kako radi iCal sinhronizacija?",
        answer:
          "RentPilot uvozi zauzete termine iz Airbnb i Booking kalendara, kreira rezervaciju/blokadu u aplikaciji i izvozi RentPilot kalendar koji možete povezati nazad na platforme.",
      },
      guests: {
        question: "Čemu služi lista gostiju?",
        answer:
          "Lista gostiju čuva kontakt podatke, broj boravaka, prihod, državu, napomene i informaciju o marketing consentu.",
      },
      cleaning: {
        question: "Kada se kreira zadatak čišćenja?",
        answer:
          "Zadatak čišćenja se kreira automatski za dan odlaska gosta, obično u 11:00, i može se dodijeliti sobarici.",
      },
      invoices: {
        question: "Mogu li poslati račun gostu?",
        answer:
          "Da. Ako gost ima e-mail adresu, račun možete poslati iz detalja rezervacije.",
      },
      subscription: {
        question: "Šta se dešava kada pretplata istekne?",
        answer:
          "Prijava ostaje moguća, ali se glavne funkcije blokiraju dok se pretplata ne obnovi.",
      },
    },
  },

  merchant: {
    title: "Podaci o trgovcu",
    description:
      "Osnovni podaci o pravnom subjektu koji pruža i naplaćuje RentPilot uslugu.",
    legalName: "Puni naziv pravnog subjekta",
    address: "Adresa",
    businessActivity: "Djelatnost",
    activityCode: "Šifra djelatnosti",
    registrationNumber: "Matični broj",
    taxNumber: "Poreski / JIB broj",
    website: "Web adresa",
    phone: "Kontakt telefon",
    email: "Kontakt email",

    customerServiceTitle: "Korisnički servis",
    customerServiceDescription:
      "Za informacije o narudžbama i plaćanju, reklamacije, otkazivanje usluge i druge upite možete nas kontaktirati putem navedenih podataka.",

    privacyTitle: "Zaštita privatnosti",
    privacyDescription:
      "RentPilot prikuplja samo podatke potrebne za pružanje usluge, upravljanje korisničkim računom, obradu narudžbi i plaćanja, korisničku podršku i ispunjavanje zakonskih obaveza. Lični podaci se ne prodaju. Podaci su dostupni samo ovlaštenim osobama i pružaocima usluga kojima su neophodni za izvršavanje njihovih obaveza. Podaci o kartici unose se isključivo na zaštićenoj stranici procesora plaćanja i nisu dostupni niti se pohranjuju u RentPilot sistemu.",
  },
};
